import type { ModalContentProps as ChakraModalContentProps } from '@chakra-ui/react';
import { ModalContent as ChakraModalContent } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type ModalContentProps = OmitChakraProps<ChakraModalContentProps>;

export const ModalContent = withChakraAs<ModalContentProps, 'section'>(
  (props) => {
    return <ChakraModalContent {...props} />;
  },
);
